import { Injectable } from '@angular/core';
import { DOMService } from './dom.service';
import { eitherRect } from '../util';
/**
 * @hidden
 */
var PositionService = /** @class */ (function () {
    function PositionService(_dom) {
        this._dom = _dom;
    }
    PositionService.prototype.positionElement = function (settings) {
        var anchor = settings.anchor, currentLocation = settings.currentLocation, element = settings.element, anchorAlign = settings.anchorAlign, elementAlign = settings.elementAlign, collisions = settings.collisions, margin = settings.margin;
        var dom = this._dom;
        var result = dom.restrictToView({
            anchorAlign: anchorAlign,
            anchorRect: eitherRect(dom.offset(anchor), currentLocation),
            collisions: collisions,
            elementAlign: elementAlign,
            elementRect: dom.offsetAtPoint(element, currentLocation),
            margin: margin,
            viewPort: settings.viewPort || dom.windowViewPort(element)
        });
        return {
            flip: result.flip,
            flipped: result.flipped,
            offset: dom.addOffset(currentLocation, result.offset)
        };
    };
    PositionService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    PositionService.ctorParameters = function () { return [
        { type: DOMService, },
    ]; };
    return PositionService;
}());
export { PositionService };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-popup/dist/es/services/position.service.js
// module id = ../../../../@progress/kendo-angular-popup/dist/es/services/position.service.js
// module chunks = vendor